import { render, staticRenderFns } from "./IcPdf.vue?vue&type=template&id=dcb2c168&scoped=true"
import script from "./IcPdf.vue?vue&type=script&lang=js"
export * from "./IcPdf.vue?vue&type=script&lang=js"
import style0 from "./IcPdf.vue?vue&type=style&index=0&id=dcb2c168&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcb2c168",
  null
  
)

export default component.exports